import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { FiltersPanelComponent } from '@src/app/shared/components/filters-panel/filters-panel.component';
import { CustomDropdownModule } from '@src/app/shared/components/dropdown/custom-dropdown.module';
import { DatePickerModule } from 'primeng/datepicker';

@NgModule({
  declarations: [FiltersPanelComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    CustomDropdownModule,
    DatePickerModule
  ],
  exports: [FiltersPanelComponent]
})
export class FiltersPanelModule { }
